import React from 'react';
import { QuickResearch } from '../components/landing';
import { useActiveView } from '../router/useUrlNavigation';
import { useShellUiActions } from '../context/ShellUiContext';

// BAR-40 S3: /quick-research route. The ?q prefill is read from the URL via
// useActiveView().quickQuery; onInitialQueryHandled clears it with replace.
export default function QuickResearchRoute() {
  const { quickQuery } = useActiveView();
  const { navigateToView } = useShellUiActions();
  return (
    <QuickResearch
      initialQuery={quickQuery || undefined}
      onInitialQueryHandled={() => navigateToView('quick-research', { replace: true })}
    />
  );
}
